import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiRequest from "@shared/services/api/apiRequest";
import { NOTIFICATIONS_API } from "../notifications.constants";

export function useNotificationReadAllMutation() {
  const queryClient = useQueryClient();

  // Mark all as read mutation
  const mutation = useMutation({
    mutationFn: async () => {
      return apiRequest(`${NOTIFICATIONS_API}mark-all-read/`, "POST");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
    },
  });

  return mutation;
}

export default useNotificationReadAllMutation;
